export const MAX_WORDS = 100;

export const AIWeddingPlannerChips = [
  "Help me create a timeline",
  "Step-by-step wedding checklist",
  "Ideas for my wedding theme",
];

export const SelectedMode = {
  CreateImage: "CreateImage",
  PlanYourWedding: "PlanYourWedding",
  AIImageEdit: "AIImageEdit",
};

export const SelectionOptions = [
  {
    label: "Create an image",
    value: SelectedMode.CreateImage,
  },
  {
    label: "Plan Your Wedding",
    value: SelectedMode.PlanYourWedding,
  },
  {
    label: "AI Image Edit",
    value: SelectedMode.AIImageEdit,
  },
];

export const QuickSelection = [
  {
    label: "Wedding Dresses",
    value: [
      {
        label: "Modest Cathedral Gown",
        value:
          "Modest cathedral bridal gown, high neckline, long sleeves, full train, elegant studio lighting",
      },
      {
        label: "Satin Off-Shoulder Ballgown",
        value:
          "Princess satin ballgown, off-shoulder, pearl details, full-body runway shot",
      },
      {
        label: "Boho Beach Dress with Veil",
        value:
          "Beach wedding boho-style dress, windswept veil, tropical shoreline",
      },
      {
        label: "Feather Gown, Sparkling Bodice",
        value:
          "Full-length feather bridal gown, sparkling bodice, flowing silhouette, off-white, soft studio lighting",
      },
      {
        label: "Couture Pearls & Diamonds One-Shoulder",
        value:
          "White couture bridal gown adorned with pearls and diamonds, dramatic ruffles, thigh-high slit, long train, one-shoulder strap, dramatic studio lighting",
      },
    ],
  },
  {
    label: "Groom Suits",
    value: [
      {
        label: "Classic Black Tuxedo with Bow Tie",
        value: "Classic black tuxedo, peak lapel, bow tie, church background",
      },
      {
        label: "Dark Green Suit No Tie",
        value: "Dark green suit, brown shoes, no tie, relaxed garden ceremony",
      },
      {
        label: "Ivory Dinner Jacket at Sunset",
        value:
          "Ivory dinner jacket, cream shirt, black trousers, sunset terrace, beach backdrop",
      },
      {
        label: "Rustic Tweed Suit Countryside",
        value:
          "Rustic tweed suit with boutonnière, English countryside barn, hedgerows and wildflower meadow",
      },
      {
        label: "Navy Velvet-Lapel Tux Rooftop",
        value:
          "Modern navy tuxedo, velvet lapel, navy bow tie, chic rooftop wedding venue, skyline background",
      },
    ],
  },
  {
    label: "Wedding Rings",
    value: [
      {
        label: "Oval Solitaire White-Gold Band",
        value:
          "Oval-cut solitaire engagement ring with white-gold band, macro detail, soft studio lighting",
      },
      {
        label: "Rose-Gold Princess-Cut Ring",
        value:
          "Rose gold engagement ring with princess-cut diamond, beach backdrop, natural sunlight, close-up sparkle",
      },
      {
        label: "Eternity Band Full Diamonds",
        value:
          "Close-up of an eternity wedding band with small diamonds all around, on hand, soft natural light, focus on fine details",
      },
      {
        label: "Slim Titanium Band on Velvet",
        value:
          "Polished titanium wedding band, thin, on midnight-blue velvet, soft glow",
      },
      {
        label: "Brushed Gold Wedding Bands",
        value:
          "Close-up of wedding rings, brushed gold bands, on a plain background",
      },
    ],
  },
  {
    label: "Wedding Cakes",
    value: [
      {
        label: "White Three-Tier Sugar Flowers",
        value: "White three-tier fondant cake with pink sugar flowers, classic",
      },
      {
        label: "Tall Blush Tiers with Ruffles",
        value:
          "Two extra-tall blush-pink tiers with ruffled accents, minimalist design, small white rosebuds",
      },
      {
        label: "Semi-Naked Cake with Berries",
        value:
          "Semi-naked wedding cake, delicately decorated with fresh berries and subtle greenery, rustic outdoor setting",
      },
      {
        label: "Modern Square Tiers Blue Accents",
        value:
          "Wedding cake, modern square-tier design, thick vertical buttercream ridges, minimalistic blue piping, elegant",
      },
      {
        label: "Five-Tier Lacework with Topper",
        value:
          "Five-tier wedding cake, intricate lacing, pastel flowers, bride and groom topper, elegant ballroom background",
      },
      {
        label: "Dessert Table Cupcake Tower",
        value:
          "Wedding dessert table, focus on cupcake tower on cake stand, floral accents, bright airy lighting",
      },
    ],
  },
  {
    label: "Flowers & Bouquets",
    value: [
      {
        label: "White Lilies & Pink Peonies",
        value:
          "Wedding bouquet, white lilies with pink peonies, light green cascading foliage, extravagant presentation",
      },
      {
        label: "Sunflowers & Cornflowers Bouquet",
        value:
          "Wedding bouquet, three large sunflowers with blue cornflowers, long-stem, hand-tied with white ribbon, sunset beach background",
      },
      {
        label: "Beach Floral Arch with Palms",
        value:
          "Wedding floral arch, yellow gerbera daisies, red anthuriums, palm leaves; beach backdrop",
      },
      {
        label: "Venue Décor Tall Centerpiece",
        value:
          "Wedding venue décor—white linens, tall accent-flower centerpiece, soft uplighting, minimalist styling",
      },
      {
        label: "Boho Daisy Headpiece with Ribbons",
        value:
          "Floral boho headpiece, delicate, small daisies, ribbon ties, airy daylight, minimal styling, sandy beach setting",
      },
    ],
  },
];

export const placeholderHomeTextArea = [
  {
    text: "Describe your wedding vision here. For example: A bride with an elegant floral updo, soft makeup, and diamond earrings, captured in romantic lighting.",
    language: "English",
  },
  {
    text: "Una novia radiante está sola con un vestido de novia espectacular, un vestido blanco fluido con mangas de encaje y una cola brillante, bajo luz suave.",
    language: "Spanish",
  },
  {
    text: "Eine strahlende Braut steht allein in einem atemberaubenden Hochzeitskleid, einem fließenden weißen Kleid mit Spitzärmeln und einer funkelnden Schleppe, in weichem Licht.",
    language: "German",
  },
  {
    text: "Une mariée éclatante se tient seule dans une robe de mariée époustouflante, une robe blanche fluide avec des manches en dentelle et une traîne étincelante, sous une lumière douce.",
    language: "French",
  },
];

export const AIWeddingPlannerPlaceholder = [
  {
    text: `Hi there! Planning your wedding? I’ve got you.\nAsk me anything — from setting a date to picking a venue or creating your timeline.\nTry: “Help me plan my wedding.”`,
    language: "English",
  },
  {
    text: "¡Hola! ¿Estás organizando tu boda? Estoy aquí para ayudarte.\nPregúntame lo que quieras: desde elegir la fecha hasta buscar un lugar o crear tu cronograma.\nPrueba con: Ayúdame a planear mi boda.",
    language: "Spanish",
  },
  {
    text: "Hallo! Planst du deine Hochzeit? Ich helfe dir gern.\nFrag mich alles — vom Datum festlegen über die Location bis hin zum Zeitplan.\nVersuch’s mit: Hilf mir, meine Hochzeit zu planen.",
    language: "German",
  },
  {
    text: "Bonjour! Vous organisez votre mariage ? Je suis là pour vous aider.\nPosez-moi toutes vos questions — fixer une date, choisir un lieu, créer votre planning.\nEssayez : Aide-moi à planifier mon mariage.",
    language: "French",
  },
];

export const AIWeddingPlannerPlaceholderResumeSession = [
  {
    text: `You’ve still got something in progress — want to continue?`,
    language: "English",
  },
  {
    text: "¡Hola! ¿Estás organizando tu boda? Estoy aquí para ayudarte.\nPregúntame lo que quieras: desde elegir la fecha hasta buscar un lugar o crear tu cronograma.\nPrueba con: Ayúdame a planear mi boda.",
    language: "Spanish",
  },
  {
    text: "Hallo! Planst du deine Hochzeit? Ich helfe dir gern.\nFrag mich alles — vom Datum festlegen über die Location bis hin zum Zeitplan.\nVersuch’s mit: Hilf mir, meine Hochzeit zu planen.",
    language: "German",
  },
  {
    text: "Bonjour! Vous organisez votre mariage ? Je suis là pour vous aider.\nPosez-moi toutes vos questions — fixer une date, choisir un lieu, créer votre planning.\nEssayez : Aide-moi à planifier mon mariage.",
    language: "French",
  },
];

export const AIWeddingPlannerPlaceholderContinuePlanning = [
  {
    text: `Hi there, good to see you again! Want to pick up right where we left off?`,
    language: "English",
  },
  {
    text: "¡Hola! ¿Estás organizando tu boda? Estoy aquí para ayudarte.\nPregúntame lo que quieras: desde elegir la fecha hasta buscar un lugar o crear tu cronograma.\nPrueba con: Ayúdame a planear mi boda.",
    language: "Spanish",
  },
  {
    text: "Hallo! Planst du deine Hochzeit? Ich helfe dir gern.\nFrag mich alles — vom Datum festlegen über die Location bis hin zum Zeitplan.\nVersuch’s mit: Hilf mir, meine Hochzeit zu planen.",
    language: "German",
  },
  {
    text: "Bonjour! Vous organisez votre mariage ? Je suis là pour vous aider.\nPosez-moi toutes vos questions — fixer une date, choisir un lieu, créer votre planning.\nEssayez : Aide-moi à planifier mon mariage.",
    language: "French",
  },
];

export const AIWeddingImageEditPlaceholder = [
  {
    text: "Upload your photo, then tell us what to change. Example: replace the flowers with pastel roses or remove people in the background.",
    language: "English",
  },
  {
    text: "Lade dein Foto hoch und sag uns, was geändert werden soll. Beispiel: die Blumen durch zartrosa Rosen ersetzen oder Personen im Hintergrund entfernen.",
    language: "German",
  },
  {
    text: "Téléversez votre photo puis dites‑nous la retouche souhaitée. Exemple : remplacer les fleurs par des roses pastel ou retirer les personnes à l’arrière‑plan.",
    language: "French",
  },
  {
    text: "Sube tu foto y cuéntanos qué cambiar. Ejemplo: reemplazar las flores por rosas pastel o eliminar a las personas del fondo.",
    language: "Spanish",
  },
];
